module.exports = __webpack_public_path__ + "static/media/youth.e0864e93.png";